import { render, staticRenderFns } from "./PartnersLife.vue?vue&type=template&id=1665c068&"
import script from "./PartnersLife.vue?vue&type=script&lang=js&"
export * from "./PartnersLife.vue?vue&type=script&lang=js&"
import style0 from "./PartnersLife.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports